import { Injectable } from '@angular/core'
import { PathNode, Task } from '@mprep/shared/data/models'

@Injectable()
export class NavigationStatusService {

  private _currentPath: PathNode
  private _currentUnit: PathNode
  private _currentSection: PathNode
  private _currentTask: Task

  public get currentPath()    { return this._currentPath }
  public get currentUnit()    { return this._currentUnit }
  public get currentSection() { return this._currentSection }
  public get currentTask()    { return this._currentTask }

  public get initialized()    { return this._currentPath instanceof PathNode }

  public initialize(currentPath: PathNode, currentUnit: PathNode, currentSection: PathNode, currentTask: Task) {
    this._currentPath = currentPath
    this._currentUnit = currentUnit
    this._currentSection = currentSection
    this._currentTask = currentTask
  }

  public paramsForPathRoute(newPathNode: PathNode = null) {
    return ['/path', newPathNode ? newPathNode.id : this._currentPath.id ]
  }

  public paramsForUnitRoute(newUnitNode: PathNode = null) {
    return this.paramsForPathRoute().concat(
      'unit', (newUnitNode ? newUnitNode.id : this._currentUnit.id)
    )
  }

  public paramsForUnitOverviewRoute(newUnitNode: PathNode = null) {
    return this.paramsForUnitRoute(newUnitNode).concat(
      'overview'
    )
  }

  public paramsForSectionRoute(newSectionNode: PathNode = null) {
    return this.paramsForUnitRoute().concat(
      'section', (newSectionNode ? newSectionNode.id : this._currentSection.id)
    )
  }

  public paramsForTaskRoute(newTaskNode: Task = null) {
    return this.paramsForSectionRoute().concat(
      'task', (newTaskNode ? newTaskNode.id : this._currentTask.id)
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/navigation-status/navigation-status.service.ts